import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { env } from './.env';
import { CommonEnvironment } from './environment.common';

export const environment = {
  production: false,
  name: 'pre',
  version: env.npm_package_version,
  server: 'pre.sabadellconsumeronline.com/',
  serverUrl: '/api',
  defaultLanguage: LOCALE_ES,
  supportedLanguages: [LOCALE_ES, 'es-CAT'],
  ...CommonEnvironment, //añadimos los environment comunes

  //API
  URL_BASE: 'https://pre.sabadellconsumeronline.com',
  URL_BASE_AUTHENTICATION: 'https://pre.sabadellconsumeronline.com/WebPrescriptor/authentication',
  URL_BASE_REQUEST: 'https://pre.sabadellconsumeronline.com/WebPrescriptor/request',
  URL_BASE_SIGNATURE: 'https://pre.sabadellconsumeronline.com/WebPrescriptor/signature',
  URL_BASE_ADMIN: 'https://pre.sabadellconsumeronline.com/WebPrescriptor/administration',
  URL_BASE_THIRDPARTY: 'https://pre.sabadellconsumeronline.com/WebPrescriptor/services',

  //URL WITH IP
  URL_BASE_IP_AUTHENTICATION_20:
    'U2FsdGVkX18JZn25Zjcu0vhVw7+tkxoOL3mp0UZELQxih8VQD9bG6styg22n7xn3q5LKDcDj1AMHCuzM3+hn3EqatCj5kD4aLpkuZrv6OvA=',
  URL_BASE_IP_AUTHENTICATION_21:
    'U2FsdGVkX1+pgBlpEgkbL/OZRaJWpVE4+hyuZzWM31AlOI0BCP0afBAKNT6FXEgOS9ay0mufWlJNpSjkT52d8x5uu8gpbqleBtpdqTKZZs0=',

  //Logalty
  URL_LOGALTY_SIGNATURE: 'https://www.demo.logalty.es/lgt/lgtfrontend/login/samlLogin',

  URL_LOGALTY_CONSENTS_JS: 'https://democonsent.logalty.com/static/js/',
  URL_LOGALTY_JS_JQUERY: 'jquery.min-3.2.1.js',
  URL_LOGALTY_JS_TINGLE: 'tingle.js',
  URL_LOGALTY_JS_CONTEXT: 'logaltyconexp.js',

  URL_LOGALTY_CONSENTS_CSS: 'https://democonsent.logalty.com/static/css/',
  URL_LOGALTY_CSS_TINGLE: 'tingle.css',
  URL_LOGALTY_CSS_CONSENT: 'consent.css',
  URL_LOGALTY_CSS_CANDLESTICK: 'candlestick.css',

  //GEOCODE CTI
  URL_GEOCODE: 'https://pre.sabadellconsumeronline.com/GeocodeSpainService',
};
